var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReducedRiskOfErrorsMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 230,
    viewBox: "0 0 240 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1523_4088)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.865 21C149.872 20.6677 149.876 20.3344 149.876 20L230 20C235.523 20 240 24.4772 240 30V220C240 225.523 235.523 230 230 230H10C4.47716 230 0 225.523 0 220V30C0 24.4772 4.47715 20 10 20L90.1245 20C90.1245 20.3344 90.1279 20.6677 90.1348 21H10C5.02944 21 1 25.0294 1 30V220C1 224.971 5.02944 229 10 229H230C234.971 229 239 224.971 239 220V30C239 25.0294 234.971 21 230 21H149.865Z",
    fill: "#31E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 20,
    r: 29.5,
    stroke: "#31E5E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1523_4088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 39.2188C130.614 39.2188 139.219 30.6142 139.219 20C139.219 9.38578 130.614 0.78125 120 0.78125C109.386 0.78125 100.781 9.38578 100.781 20C100.781 30.6142 109.386 39.2188 120 39.2188Z",
    fill: "#031F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 39.1797C130.593 39.1797 139.18 30.5926 139.18 20C139.18 9.40735 130.593 0.820312 120 0.820312C109.407 0.820312 100.82 9.40735 100.82 20C100.82 30.5926 109.407 39.1797 120 39.1797Z",
    stroke: "#31E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57 11.7974V23.8834H109.462C109.459 23.8149 109.455 23.7744 109.455 23.734C109.455 19.8431 109.456 15.9524 109.458 12.0619C109.459 11.8971 109.48 11.7331 109.521 11.5737C109.743 10.7218 110.473 10.189 111.409 10.1887C117.127 10.1883 122.845 10.1883 128.563 10.1887C128.632 10.1887 128.701 10.1863 128.769 10.1905C129.494 10.2336 130.035 10.5718 130.368 11.2177C130.449 11.4058 130.517 11.5995 130.57 11.7972M125.58 17.0357C125.58 13.9533 123.067 11.4234 120.007 11.4263C116.957 11.4293 114.451 13.9524 114.445 17.0255C114.44 20.107 116.95 22.6427 120.007 22.6459C123.065 22.6491 125.58 20.1177 125.58 17.0359",
    fill: "#4BAF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57 25.9869C130.517 26.1846 130.449 26.3782 130.367 26.5661C130.035 27.2126 129.493 27.5494 128.769 27.5943C128.762 27.5943 128.755 27.5943 128.748 27.5943C122.928 27.5946 117.107 27.5939 111.286 27.5922C110.876 27.5929 110.479 27.4546 110.158 27.2C109.837 26.9454 109.612 26.5894 109.52 26.1904C109.445 25.854 109.458 25.4977 109.43 25.1206H130.57V25.9869Z",
    fill: "#378C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.899 29.8116C114.879 29.7953 114.858 29.7804 114.836 29.7673C114.54 29.6176 114.394 29.3454 114.459 29.0654C114.529 28.7634 114.774 28.5764 115.109 28.5748C115.651 28.5724 116.193 28.5742 116.735 28.5742H116.918V27.3467H123.1V28.5742H123.496C123.95 28.5742 124.403 28.5742 124.856 28.5742C125.248 28.5742 125.491 28.743 125.567 29.0654C125.635 29.3572 125.489 29.6098 125.151 29.7811C125.141 29.7864 125.135 29.8011 125.127 29.8116H114.899Z",
    fill: "#378C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.343 17.0321C124.345 19.4336 122.385 21.4115 120.006 21.4085C117.637 21.4052 115.684 19.432 115.683 17.0396C115.681 14.6381 117.64 12.6611 120.02 12.6641C122.389 12.6667 124.341 14.6393 124.343 17.0321M120.631 15.78C120.631 15.3684 120.635 14.9566 120.63 14.545C120.626 14.1778 120.365 13.9059 120.02 13.9017C119.667 13.8975 119.397 14.1729 119.395 14.5509C119.392 15.3675 119.392 16.184 119.395 17.0003C119.396 17.3805 119.663 17.6559 120.016 17.6541C120.368 17.6523 120.627 17.3769 120.63 16.9944C120.634 16.5897 120.631 16.1847 120.631 15.78M120.004 20.178C120.086 20.1782 120.168 20.1621 120.244 20.1307C120.32 20.0992 120.39 20.053 120.448 19.9947C120.506 19.9364 120.552 19.8671 120.584 19.7909C120.615 19.7147 120.631 19.633 120.631 19.5505C120.626 19.3879 120.559 19.2332 120.444 19.1185C120.328 19.0037 120.173 18.9378 120.01 18.9342C119.928 18.9345 119.847 18.951 119.771 18.9829C119.695 19.0147 119.626 19.0613 119.568 19.1199C119.51 19.1785 119.464 19.248 119.433 19.3243C119.402 19.4007 119.387 19.4824 119.387 19.5648C119.388 19.7277 119.454 19.8836 119.569 19.9985C119.685 20.1133 119.841 20.1778 120.004 20.1778",
    fill: "#F9F9F9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#31E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1523_4088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 210,
    fill: "white",
    transform: "translate(0 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1523_4088"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducedRiskOfErrorsMob);
export default __webpack_public_path__ + "static/media/ReducedRiskOfErrorsMob.20a4c5d27b52abd5dfe860d358810e10.svg";
export { ForwardRef as ReactComponent };